import type { Task } from "@gearbox-protocol/deploy-tools-shared";
import { useParams } from "react-router-dom";

import { useUnpausedForkStatus } from "../context";

export default function useTask(): Task | undefined {
  const fork = useUnpausedForkStatus();
  const { taskId } = useParams();

  return fork.tasks?.find(t => t.id === taskId);
}
